import { apiSlice } from "../app/api/apiSlice";

export const assetApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssets: builder.query({
      query: (section) => ({ url: `asset?section=${section}` }),
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
    }),
  }),
});

export const { useGetAssetsQuery } = assetApiSlice;
